// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-use[data-v-35ddaad8] {\n  position: relative;\n  display: flex;\n  opacity: 0.6;\n  padding-left: 14px;\n  padding-top: 10px;\n  width: 72px;\n}\n.no-use > span[data-v-35ddaad8] {\n  font-weight: bold;\n  position: absolute;\n  width: inherit;\n  text-align: center;\n  padding-top: 25px;\n}\n.my > .no-use > img[data-v-35ddaad8] {\n/*   width: 66px !important;\n  padding-left: 2px !important; */\n}\n\n", ""]);
// Exports
module.exports = exports;
